/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/forward-5-rec";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "Forward5Rec";
export { I as Forward5Rec };
